const { forEach } = require("lodash");

var cookies = document.querySelector('#cookies-policy');
var cookiesConfigPopup = document.querySelector('#cookie-config-popup');
var reset = document.querySelector('.cookiereset');
var settingsBtn = document.querySelector('.cookiesBtn__link.settings');

if(reset) {
    reset.addEventListener('submit', (event) => resetNew(event))
}
document.querySelector('#reset-cookie-form').addEventListener('submit', (event) => resetNew(event))

if(cookies) {
    var customize = cookies.querySelector('.cookies__btn--customize');
    var details = cookies.querySelectorAll('.cookies__details');
    var detailsPopup = cookiesConfigPopup.querySelectorAll('.cookies__details');
    var acceptAll = cookies.querySelector('.cookiesBtn--accept');
    var acceptEssentials = cookies.querySelector('.cookies__btn.essentials');
    var configure = cookies.querySelector('.cookies__customize');
    var configurePopup = cookiesConfigPopup.querySelector('.cookies__customize');
    var text = JSON.parse(cookies.getAttribute('data-text'))
    var popupCloseIcon = cookiesConfigPopup.querySelector('.close-graph')

    initCookies();

    for (let i = 0; i < details.length; i++) {
        details[i].addEventListener('click', (event) => toggleExpand(event, event.target, false));
    }
    for (let i = 0; i < detailsPopup.length; i++) {
        detailsPopup[i].addEventListener('click', (event) => toggleExpand(event, event.target, false, true));
    }
    customize.addEventListener('click', (event) => toggleExpand(event, customize));
    acceptAll.addEventListener('submit', (event) => acceptAllCookies(event));
    acceptEssentials.addEventListener('submit', (event) => acceptEssentialsCookies(event));
    configure.addEventListener('submit', (event) => configureCookies(event));
    configurePopup.addEventListener('submit', (event) => configureCookies(event));
    window.addEventListener('resize', (event) => resize(event));
    popupCloseIcon.addEventListener('click', closePopup);
    settingsBtn?.addEventListener('click', openSettings);
    // deleteAllCookie()
}

function initCookies() {
    cookies.removeAttribute('data-text');
    cookies.classList.remove('cookies--no-js');
    cookies.classList.add('cookies--closing');

    setTimeout(function() {
        cookies.classList.remove('cookies--closing');
    }, 310);
}

function configureCookies(event)  {
    event.preventDefault();

    let adInput = document.querySelector('#cookies-policy-check-ad-cookie')
    let analyticsInput = document.querySelector('#cookies-policy-check-analytics')
    changeGoogleStatus(analyticsInput.checked, adInput.checked);
    if(!analyticsInput.checked || !adInput.checked ) {
        deleteAllCookie()
    }

    window.LaravelCookieConsent.configure(new FormData(event.target)).then((response) => window.location.reload());
    close();
}

function acceptAllCookies(event) {
    event.preventDefault();
    changeGoogleStatus(true, true);

    window.LaravelCookieConsent.acceptAll().then((response) => window.location.reload());
    close();
}

function acceptEssentialsCookies(event) {
    event.preventDefault();
    changeGoogleStatus(false, false);
    deleteAllCookie()
    window.LaravelCookieConsent.acceptEssentials().then((response) => window.location.reload())
    close();
}

function resetCookies(event) {
    event.preventDefault();
    if(document.querySelector('#cookies-policy')) return;
    changeGoogleStatus(false, false);
    window.LaravelCookieConsent.reset().then((response) => deleteAllCookie())//, window.location.reload())


}
function resetNew(event) {
    event.preventDefault();
    // cookies.classList.add('cookies--show')
    // cookies.querySelector('.cookies__container').classList.add('cookies__container--hide')
    // // cookies.querySelector('.cookies__btn--customize').dispatchEvent(new Event('click'))
    // cookies.querySelector('#cookies-policy-customize').classList.add('cookies__expandable--open')
    
    cookiesConfigPopup.classList.remove('dnone')

    return false;
}

function resize() {
    if (window.innerHeight <= cookies.offsetHeight) {
        cookies.querySelector('.cookies__sections').style.maxHeight = '50vh';
    } else {
        cookies.querySelector('.cookies__sections').removeAttribute('style')
    }
}

function toggleExpand(event, el, hide = true, isPopup = false) {
    event.preventDefault();
    event.target.blur();

    var element = isPopup ? cookiesConfigPopup.querySelector(el.getAttribute('href')) : cookies.querySelector(el.getAttribute('href')),
        content = element.firstElementChild,
        height = content.offsetHeight,
        isOpen = element.classList.contains('cookies__expandable--open');

    element.setAttribute('style', 'height:' + (isOpen ? height : 0) + 'px');

    changeText(hide, isOpen, event);

    setTimeout(((cookies) => function() {
        element.classList.toggle('cookies__expandable--open');
        element.setAttribute('style', 'height:' + (isOpen ? 0 : height) + 'px');

        setTimeout(function() {
            element.removeAttribute('style');
        }, 310);
    })(cookies), 10);

    hideNotice(hide, isOpen)
}

function changeText(hide, isOpen, event) {
    if(hide) return;

    event.target.textContent = isOpen
        ? text.more
        : text.less
}

function hideNotice(hide, isOpen) {
    if(!hide) return;

    var container = cookies.querySelector('.cookies__container'),
        containerHeight = container.firstElementChild.offsetHeight;

    container.setAttribute('style', 'height:' + (!isOpen ? containerHeight : 0) + 'px');

    setTimeout(((cookies) => function() {
        cookies.classList.toggle('cookies--show')
        container.classList.toggle('cookies__container--hide');
        container.setAttribute('style', 'height:' + (isOpen ? containerHeight : 0) + 'px');

        setTimeout(function() {
            container.removeAttribute('style');
        }, 320);
    })(cookies), 10);
}

function close() {
    cookies.classList.add('cookies--closing');

    setTimeout(((cookies) => { return () => {
        if (!cookies.parentNode) return;

        let scripts = cookies.parentNode.querySelectorAll('[data-cookie-consent]');

        scripts.forEach(script => {
            script.parentNode.removeChild(script);
        });

        cookies.parentNode.removeChild(cookies);

    }})(cookies), 210);
}

function deleteAllCookie() {
    let cookieArr = document.cookie.split(';')
    let newCookieList = '';
    cookieArr.forEach(cookie => {
        if(cookie.includes('XSRF-TOKEN') || cookie.includes('proleasing_session') || cookie.includes('proleasing_cookie_consent') || cookie.includes('laravel_session') || cookie.includes('laravel_cookie_consent')) {
            return;
        } else {
            let eqPos = cookie.indexOf('=');
            let name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
    })
    document.cookie = newCookieList
}
function changeGoogleStatus(analytic, ad) {
    gtag('consent', 'update', {
        'ad_storage': ad ? 'granted' : 'denied',
        'ad_user_data': ad ? 'granted' : 'denied',
        'ad_personalization': ad ? 'granted' : 'denied',
        'analytics_storage': analytic ? 'granted': 'denied'
    });
}
function closePopup(e) {
    cookiesConfigPopup.classList.add('dnone')
}

function openSettings(e) {
    customize.dispatchEvent(new Event('click'))
}
